import React from "react";


function Skills() {
    return (
        <div className="skills-container">
            <div className="skills-content">
                <div className="skills-title">
                    <h1>Skills</h1>
                </div>
                <div className="heading-one">
                    <h2>Languages</h2>
                    <div className="languages-icons">
                        <div className="skill">
                            <img src="/assets/icons/js.png" alt="JavaScript" width="100" height="auto"/>
                            <div className="skill-overlay">JavaScript</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/html.png" alt="HTML" width="100" height="auto"></img>
                            <div className="skill-overlay">HTML</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/css-3.png" alt="CSS" width="100" height="auto"></img>
                            <div className="skill-overlay">CSS</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/python.png" alt="Python" width="100" height="auto"></img>
                            <div className="skill-overlay">Python</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/java.png" alt="Java" width="100" height="auto"></img>
                            <div className="skill-overlay">Java</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/PHP.png" alt="PHP" width="100" height="auto"></img>
                            <div className="skill-overlay">PHP</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/C++ (CPlusPlus).png" alt="C++" width="100" height="auto"></img>
                            <div className="skill-overlay">C++</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/TypeScript.png" alt="TypeScript" width="100" height="auto"></img>
                            <div className="skill-overlay">TypeScript</div>
                        </div>
                    </div>
                </div>
                <div className="heading-two">
                    <h2>Tools & Platforms</h2>
                    <div className="tools-platforms-icons">
                        <div className="skill">
                            <img src="/assets/icons/React.png" alt="React" width="100" height="auto"></img>
                            <div className="skill-overlay">React</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Next.js.png" alt="Next.js" width="100" height="auto"></img>
                            <div className="skill-overlay">Next.js</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Node.js.png" alt="Node.js" width="100" height="auto"></img>
                            <div className="skill-overlay">Node.js</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/GitHub.png" alt="GitHub" width="100" height="auto"></img>
                            <div className="skill-overlay">GitHub</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Git.png" alt="Git" width="100" height="auto"></img>
                            <div className="skill-overlay">Git</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Docker.png" alt="Docker" width="100" height="auto"></img>
                            <div className="skill-overlay">Docker</div>
                        </div>
                        <div className="skill">
                        <img src="/assets/icons/PostgresSQL.png" alt="PostgreSQL" width="100" height="auto"></img>
                            <div className="skill-overlay">PostgreSQL</div>
                        </div>
                        <div className="skill">
                        <img src="/assets/icons/MySQL.png" alt="MySQL" width="100" height="auto"></img>
                            <div className="skill-overlay">MySQL</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Confluence.png" alt="Confluence" width="100" height="auto"></img>
                            <div className="skill-overlay">Confluence</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Jira.png" alt="Jira" width="100" height="auto"></img>
                            <div className="skill-overlay">Jira</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Cloudflare.png" alt="Cloudflare" width="100" height="auto"></img>
                            <div className="skill-overlay">Cloudflare</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Vercel.png" alt="Vercel" width="100" height="auto"></img>
                            <div className="skill-overlay">Vercel</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Redis.png" alt="Redis" width="100" height="auto"></img>
                            <div className="skill-overlay">Redis</div>
                        </div>

                    </div>
                </div>
                <div className="heading-three">
                    <h2>Development Tools</h2>
                    <div className="development-tools-icons">
                        <div className="skill">
                            <img src="/assets/icons/Visual Studio Code (VS Code).png" alt="VS Code" width="100" height="auto"></img>
                            <div className="skill-overlay">VS Code</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/IntelliJ IDEA.png" alt="IntelliJ" width="100" height="auto"></img>
                            <div className="skill-overlay">IntelliJ</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Android Studio.png" alt="Android Studio" width="100" height="auto"></img>
                            <div className="skill-overlay">Android Studio</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Figma.png" alt="Figma" width="100" height="auto"></img>
                            <div className="skill-overlay">Figma</div>
                        </div>
                        <div className="skill">
                            <img src="/assets/icons/Postman.png" alt="Postman" width="100" height="auto"></img>
                            <div className="skill-overlay">Postman</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Skills;